module.exports = __webpack_public_path__ + "static/media/icon-graph-legend-arrow.e3054161.svg";